{
    "Body": [
        "body"
    ],
    "IDs": [
        "cookie-consent-div",
        "cookie-consent-label",
        "cookie-consent-button",
        "welcome-div",
        "authentication-div",
        "authentication-button",
        "error-div",
        "platform-div",
        "toggle-theme-button",
        "options-dialog",
        "speed-selector",
        "state-to-load-input"
    ],
    "Classes": [
        "initial-buttons",
        "grid-cell",
        "simulation-buttons",
        "options-dialog-element",
        "options-dialog-label",
        "options-dialog-buttons"
    ]
}
